var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSnowflake = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0v22h-2V0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m13.3.3 1.4 1.4L11 5.4 7.3 1.7 8.7.3 11 2.6zM11 16.6l3.7 3.7-1.4 1.4-2.3-2.3-2.3 2.3-1.4-1.4zM2 4.6l19 11-1 1.8-19-11z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m2.8 3.7 2-.6 1.3 5.1-5 1.4-.6-2 3.2-.8zM20.9 12.4l.6 2-3.2.8.9 3.1-2 .6-1.3-5.1zM20 4.6l1 1.8-19 11-1-1.8z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m17.2 3.1 2 .6-.9 3.1 3.2.8-.6 2-5-1.4zM.5 14.4l.6-2 5 1.4-1.3 5.1-2-.6.9-3.1z"
})));
export default SvgSnowflake;